module.exports = __webpack_public_path__ + "8c9f6da2d3e38c4c04d8a3ba8ed98d19.png";